


























































































import { computed, defineComponent, PropType, toRefs, ref } from '@vue/composition-api';
import SelectListOperator from '@/components/common/select-list-operator/index.vue';
import TooltipInfo from '@/components/common/tooltip-info/index.vue';
import { trackEvent } from './../../../../utils/index';
import { useAdgroupMode } from '@tt4b/ttam-hooks';
import { CreateMode } from '@tt4b/ttam-enums';
import { checkIsPremiumAgeAudience } from '../hooks';
import { i18n } from './../../../../i18n';

const name = 'ttam-audience-dmp-select';
export default defineComponent({
  name,
  components: {
    TooltipInfo,
    SelectListOperator,
  },
  props: {
    value: {
      type: Array as PropType<Array<number>>,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disabledTips: {
      type: String,
      default: '',
    },
    offlineTagTips: {
      type: String,
      default: '',
    },
    selectTreeProps: {
      type: Object,
      default: () => ({}),
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    buttonDisabled: {
      type: Boolean,
      default: false,
    },
    createNewHref: {
      type: String,
      default: '',
    },
    from: {
      type: String,
      default: '',
    },
    createMode: {
      type: String as PropType<CreateMode>,
      default: CreateMode.CREATE,
    },
  },
  setup(props, { emit }) {
    const { value, offlineTagTips, createMode } = toRefs(props);
    const treeValue = computed({
      get: () => value.value,
      set: val => {
        emit('input', val);
        emit('change', val);
      },
    });
    const { isEdit, isCreate } = useAdgroupMode({
      createMode,
    });
    const onRefresh = () => {
      trackEvent('create_adg_target_aud_exclude_refresh');
      emit('refresh');
    };
    const hasInteracted = ref(false);
    const isShowOfflineTagTips = computed(
      () => (isEdit.value || isCreate.value) && !hasInteracted.value && Boolean(offlineTagTips.value),
    );
    const onTreeOptionsClose = () => {
      hasInteracted.value = true;
    };
    const onCreate = () => {
      trackEvent('create_adgroup_audience_exclude_create', {
        from: props.from,
      });
      setTimeout(() => {
        window.open(props.createNewHref, '_blank');
      });
    };
    const selectedLabel = selectedKeys => {
      if (!selectedKeys?.length) {
        return '';
      }
      return i18n.t('adgroup_audicence_dmp_selected_plural', { num: selectedKeys.length });
    };
    return {
      name,
      treeValue,
      isShowOfflineTagTips,
      checkIsPremiumAgeAudience,
      onRefresh,
      onCreate,
      onTreeOptionsClose,
      selectedLabel,
    };
  },
});
